import { Col, Row } from "reactstrap";
import Indicadores from "../components/dashboard/Indicadores";


import Blog from "../components/dashboard/Blog";
import bg1 from "../assets/images/bg/chagas.jpg";
import bg2 from "../assets/images/bg/hans.jpg";
import bg3 from "../assets/images/bg/leish.jpg";
import bg4 from "../assets/images/bg/calazar.jpg";
import bg5 from "../assets/images/bg/turb.jpg";

const BlogData = [
  {
    image: bg1,
    title: "Doença de Chagas",
   /*  subtitle: "2 comentários, 1 Like", */
    description:
      "Fluxograma de atenção a pacientes com Doença de Chagas no estado do Piauí.",
    btnbg: "warning",
    href: "/chagas1"
  },
  {
    image: bg2,
    title: "Hanseníase",
    description:
      "Fluxograma de atenção a pacientes com Hanseníase no estado do Piauí.",
    btnbg: "warning",
    href: "/hans_Geral"
  },
  {
    image: bg3,
    title: "Leishmaniose",
    description:
      "Fluxograma de atenção a pacientes com Leishmaniose Tegumentar Americana no estado do Piauí.",
    btnbg: "warning",
    href: "/Leish1"
  },
  {
    image: bg4,
    title: "Calazar",
    description:
      "Fluxograma de atenção a pacientes com Calazar no estado do Piauí.",
    btnbg: "warning",
    href: "/calazar1"
  },
  {
    image: bg5,
    title: "Tuberculose",
    description:
      "Fluxograma de atenção a pacientes com Tuberculose no estado do Piauí.",
    btnbg: "warning",
    href: "/TB_Geral"
  },
];

const Starter = () => {
  return (
    <div>
      {/***Top Cards***/}
      
      {/***Gráficos***/}
      {/* <Row>
        <Col sm="6" lg="6" xl="7" xxl="8">
          <SalesChart />
          <LetalidadeChart />
          <ObitosChart />
          <AgravosChart />
          <CompulsoriaChart />
          <AgravosAChart />
          <CompulsoriaAChart />

        </Col>
        
        <Col sm="6" lg="6" xl="5" xxl="4">
          <Feeds />
        </Col>

      </Row>
 */}

      {/***Tabela de Projetos ***/}
      {/* <Row>
        <Col lg="12">
          <ProjectTables />
        </Col>
      </Row> */}


      {/***Blog Cards***/}
      <Row>
        {BlogData.map((blg, index) => (
          <Col sm="6" lg="6" xl="3" key={index}>
            <Blog
              image={blg.image}
              title={blg.title}
              subtitle={blg.subtitle}
              text={blg.description}
              color={blg.btnbg}
              href={blg.href}
            />
          </Col>
        ))}
      </Row>

      <Row>
        <Col lg="12">
          <Indicadores />
        </Col>
      </Row>
    </div>
  );
};

export default Starter;
